import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { SubgroupPicker, SubgroupPickerSchema } from './SubgroupPicker';

export const SubgroupPickerExtension = FormFieldBlueprint.make({
  name: 'SubgroupPicker',
  params: {
    field: async () =>
      createFormField({
        name: 'SubgroupPicker',
        component: SubgroupPicker,
        schema: SubgroupPickerSchema,
      }),
  },
});
